
document.addEventListener('DOMContentLoaded', function() {
    const links = document.querySelectorAll('.links .download');
    links.forEach(function(link) {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            const fileUrl = link.getAttribute('href');
            const cleanUrl = fileUrl.split('?')[0].split('#')[0];
            const filename = cleanUrl.split('/').pop();
            const fileExtension = cleanUrl.split('.').pop().toLowerCase();
            
            // Check if the file extension is PDF, MP3, or MP4
            if (fileExtension === 'pdf' || fileExtension === 'mp3' || fileExtension === 'mp4') {
                fetch(cleanUrl)
                    .then(response => response.blob())
                    .then(blob => {
                        const blobUrl = window.URL.createObjectURL(blob);
                     
                        const tempLink = document.createElement('a');
                        tempLink.href = blobUrl;
                        tempLink.setAttribute('download', filename); 
                        document.body.appendChild(tempLink);
                        
                        tempLink.click();
                   
                        document.body.removeChild(tempLink);
                        window.URL.revokeObjectURL(blobUrl);
                    })
                    .catch(error => console.error('Error downloading the file:', error));
            } else {
                console.error('Unsupported file type:', fileExtension);
            }
        });
    });
});
